import { AppointmentInfo, CreateAppointmentStatus } from '@/models';

export interface AppointmentState {
  appointment: AppointmentInfo | null;
  searchStartDate: Date | null;
  status: CreateAppointmentStatus | null;
}

export const InitialState: AppointmentState = {
  appointment: null,
  searchStartDate: null,
  status: null
}
